// Fetch avec timeout — évite qu'une requête vers l'API admin (bandeau, popup
// vacances, galerie) reste en attente indéfiniment si le serveur répond très
// lentement sans être réellement en panne. N'élimine pas les erreurs réseau
// loguées par le navigateur lui-même (ex: serveur admin éteint en dev) —
// ça, c'est natif au navigateur, aucun code JS ne peut le masquer.
export async function fetchWithTimeout(url, timeoutMs = 5000) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(url, { signal: controller.signal });
    return res.ok ? res.json() : null;
  } finally {
    clearTimeout(timer);
  }
}
